import { Link } from 'react-router-dom';

export default function CompanyHero() {
  return (
    <section className="relative w-full overflow-hidden bg-gradient-to-br from-brand-800 via-brand-700 to-brand-600">
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='40' cy='40' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="absolute right-0 top-0 w-[45%] h-full hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-brand-800/30 to-brand-700/90"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20cold%20storage%20logistics%20team%20in%20clean%20modern%20industrial%20facility%20with%20blue%20steel%20racking%20and%20organized%20frozen%20food%20cartons%20in%20background%2C%20collaborative%20work%20environment%2C%20warehouse%20workers%20in%20insulated%20gear%20reviewing%20digital%20tablets%2C%20warm%20professional%20lighting%2C%20editorial%20corporate%20photography%20style%2C%20diverse%20Indian%20team&width=900&height=800&seq=freshhlock-company-hero&orientation=portrait"
          alt="Freshhlock team at cold storage facility"
          className="w-full h-full object-cover opacity-18"
        />
      </div>

      <div className="container-page relative z-10">
        <div className="flex flex-col lg:flex-row items-center min-h-[440px] md:min-h-[500px] py-16 md:py-20">
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500/40 border border-brand-400/30 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-400"></div>
              <span className="text-xs font-medium text-brand-100 uppercase tracking-widest">
                Company
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-paper-50 leading-tight mb-5 text-balance">
              About Freshhlock
            </h1>
            <p className="text-base md:text-lg text-brand-100/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              We&apos;re building the digital backbone of India&apos;s frozen food network — connecting warehousing, transport, wholesale and retail into one intelligent platform. Here&apos;s our story, our mission, and the team making it happen.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/careers"
                className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Join Our Team
              </Link>
              <Link
                to="/contact"
                className="px-8 py-3.5 border border-brand-300/50 hover:border-paper-50/80 text-paper-50 font-medium text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                Get in Touch
              </Link>
            </div>
          </div>
          <div className="hidden lg:block w-2/5"></div>
        </div>
      </div>
    </section>
  );
}